import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { EMarket } from 'legacy/lut/configs/geo'
import { appGetState } from 'legacy/lut/store'
import { useEffect, useState } from 'react'

import { CrudStore } from 'core/types/crudStore'
import settings from 'src/config/settings'

export const useChinaPBM = (pid: string) => {
  const [isChinaPBM, setChinaPBM] = useState(false)
  const [isPBM] = useState(
    !!appGetState().user.roleIds.find((role) => ['PBM', 'Read Only'].includes(role))
  )

  const fetchChinaPBM = async () => {
    if (appGetState().user.geoMarket === EMarket.greaterChina) {
      setChinaPBM(true)
    } else if (pid) {
      CrudStore.get(CrudStoreItem.PartnerAllData)
        .getById({ id: pid, keyField: 'PartnerID' })
        .then((item) => {
          if (item && item.Market === EMarket.greaterChina) {
            setChinaPBM(true)
          } else {
            setChinaPBM(false)
          }
        })
    }
  }

  useEffect(() => {
    if (settings.appIdentifier.id === 'hpscoutso') {
      setChinaPBM(false)
      isPBM && fetchChinaPBM()
    }
  }, [pid, isPBM])

  return isChinaPBM
}
